<template>
  <div class="content-ht">
    <nav
      class="main-header"
      :class="{ 'theme-admin': (roleId === 5 || roleId === 7 || roleId === 11 ) }"
    >
      <!-- Extra sidebar for Mobile Device -->
      <div class="mobileHeader" :class="{'displayBlock':displaySide}">
        <div class="media-sidebar">
          <div class="page-description">{{userCompany}}</div>
          <div class="mobile-user-info">
            <img class="profilePicMobile" v-if="!loggedInInitialsFlag" :src="imageData" />
            <span
              class="profilePicMobile profile-pic-title"
              v-if="loggedInInitialsFlag"
            >{{loggedInInitials}}</span>
            <span
              class="userProfileDropDownMobile collapsed parentCollapse"
              id="userProfileSettings"
              href="#settingsDropDown"
              data-toggle="collapse"
            >
              <span class="ellipsis-profile-name">{{profileName}}</span>
              <img
                src="/static/images/icons/upArrow.svg"
                class="downCarret ml-13 profileCarret mobile-screen-caret"
              />
              <img src="/static/images/icons/upArrow.svg" class="upCarret ml-13 profileCarret  mobile-screen-caret" />
            </span>
          </div>
        </div>
      </div>
      <div class="logo_wrapper">
        <span class="burger-toggle" @click="$emit('mobilesidebar')">
          <svg
            width="28"
            height="20"
            viewBox="0 0 28 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="1"
              y1="1"
              x2="27"
              y2="1"
              stroke="#3E3E3E"
              stroke-width="2"
              stroke-linecap="round"
            />
            <line
              x1="1"
              y1="10"
              x2="27"
              y2="10"
              stroke="#3E3E3E"
              stroke-width="2"
              stroke-linecap="round"
            />
            <line
              x1="1"
              y1="19"
              x2="27"
              y2="19"
              stroke="#3E3E3E"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <div class="cart-alert-icons">
        <li id="cart-icon" class="pl-30" v-if="roleId === 1">
                  <img  src="static/images/icons/HeaderCartHighlight.svg" class="cursor-pointer" @click="$router.push('/layout/viewCart')" v-if="(Object.keys(cart).length !== 0)" />
                  <img src="static/images/icons/viewCart.svg" class="cursor-pointer" @click="$router.push('/layout/viewCart')" v-else/>
                </li>
                <li id="alert-icon" class="pl-13" v-if="((subscriptions.filter(obj => obj.subscriptionId === 2).length > 0) && (subscriptions.filter(obj => obj.subscriptionId === 2)[0].isActive === true))">
                  <img src="static/images/icons/HeaderNotificationHighlight.svg" class="cursor-pointer" @click="openAlertsModal" v-if="alertsList.length > 0" />
                  <img src="static/images/icons/dashboard_notifications_icon.svg" class="cursor-pointer" @click="openAlertsModal" v-else/>
                </li>
        </div>
        <router-link to="/layout/dashboard" class="div-center">
          <img class="img-responsive" src="/static/images/logos/ulimage.svg" alt="rams-logo" />
        </router-link>
      </div>
      <div class="body-wrapper">
        <div class="col-lg-5 col-md-5 col-sm-5 pl-0" style="padding-left:0px">
          <div class="l1"></div>
          <div class="col-md-11 col-sm-11">
             <p class="logo-text mb-0">Conformity Declaration Management</p>
          </div>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7">
          <div class="help-support">
            <div class="section-support" v-if="(roleId != 5 && roleId != 7 && roleId != 11)">
            </div>
            <div class="section-support-info">
              <ul
                class="pd-lt-0 mb-0 d-flex"

                :class="{ 'mt-7': (roleId === 5 || roleId === 7 || roleId === 11)}"
              >
              <li v-if="roleId === roleInfo['Super Admin']" class="admin-title">{{$t('admin')}}</li>
              <li @click="openFeedback" class="feedback"><img src="/static/images/icons/Thumbs.svg"/>{{$t('feedback')}}</li>
                <li :class="roleId === roleInfo['Super Admin'] ? 'pt-9': 'pt-9'">
                  <div class="d-flex justify-content-end align-items-center">
                    <div class="lang-dropdown">
                      <multiselect
                      :showLabels="false"
                      class="multiselect-single-dropdown"
                      :placeholder="$i18n.locale === 'Portuguese' ? 'Português' : 'English'"
                      v-model="selectedLanguageLabel"
                      :options="languages"
                      :searchable="false"
                      @select="changeLanguage"
                      >
                    </multiselect>
                  </div>
                  </div>
                </li>
                 <li class="pl-30" :class="(Object.keys(cart).length !== 0) ? 'pt-8' : 'ptb-13'" v-if="roleId === 1">
                  <img  src="static/images/icons/HeaderCartHighlight.svg" class="cursor-pointer" @click="$router.push('/layout/viewCart')" v-if="(Object.keys(cart).length !== 0)" />
                  <img src="static/images/icons/viewCart.svg" class="cursor-pointer" @click="$router.push('/layout/viewCart')" v-else/>
                </li>
                <li class="pl-13 ptb-11" v-if="((subscriptions.filter(obj => obj.subscriptionId === 2).length > 0) && (subscriptions.filter(obj => obj.subscriptionId === 2)[0].isActive === true))">
                  <img src="static/images/icons/HeaderNotificationHighlight.svg" class="cursor-pointer top-3" @click="openAlertsModal" v-if="alertsList.length > 0" />
                  <img src="static/images/icons/dashboard_notifications_icon.svg" class="cursor-pointer" @click="openAlertsModal" v-else/>
                </li>
                <li
                  class="profile-pic avatar-background  mt-7 ml-13 mr-4"
                  v-if="!loggedInInitialsFlag"

                  v-bind:style="{ backgroundImage: 'url(' + imageData + ')' }"
                ></li>
                <li
                  class="profile-pic profile-pic-title mt-7 ml-13 mr-4"
                  v-if="loggedInInitialsFlag"

                ><span class="profile-title">{{loggedInInitials}}</span></li>
                  <li class="carretSection userProfileCarret"
               >
               <div class="collapse navbar-collapse p-0" id="collapseProfileNameDropdown">
                <ul class="navbar-nav">
                  <li class="nav-item dropdown dropdown-wrapper" ref="dropdown">
                  <a ref="account-settings-dropdown-arrows" class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <!-- dropdown -->
                    <span>
                      <button>
                          <img src="/static/images/icons/upArrow.svg" class="downCarret" @click="setDropDownsToDefaultView" />
                          <img src="/static/images/icons/upArrow.svg" class="upCarret" />
                      </button>
                    </span>
                  </a>
                  <div class="dropdown-menu">
                      <form class="accordion" id="accordionExample">
                          <div class="user-profile-wrapper">
                              <a class="nav-link ptb-6 option-header profile-wrapper" data-toggle="collapse" data-target="#collapseOneProfile" aria-expanded="false" aria-controls="collapseOneProfile" ref="profile-dropdown-arrows">
                                  {{$t('profile')}}
                                  <img data-toggle="collapse" data-target="#collapseOneProfile" aria-expanded="false" aria-controls="collapseOneProfile" src="/static/images/icons/upArrow.svg" class="downCarret inner-arrow" />
                                  <img data-toggle="collapse" data-target="#collapseOneProfile" aria-expanded="false" aria-controls="collapseOneProfile" src="/static/images/icons/upArrow.svg" class="upCarret inner-arrow" />
                              </a>
                              <div id="collapseOneProfile" class="collapse px-3" aria-labelledby="headingOne" data-parent="#accordionExample" ref="innerDropdown">
                                  <div class="ptb-6 pl-15 inner-options" @click="openPopup('profile')">{{$t('userProfile')}}</div>
                                  <div class="ptb-6 pl-15 inner-options" @click="openPopup('companyProfile')">{{$t('companyProfile')}}</div>
                              </div>
                          </div>
                          <div v-if="roleId == 1 || roleId == roleInfo['Super Admin'] || roleId == roleInfo['RA Admin']" class="mt-7-mb-3">
                              <a class="nav-link ptb-6 option-header accountsettings-wrapper" data-toggle="collapse" data-target="#collapseInnerAccountSettings" aria-expanded="false" aria-controls="collapseInnerAccountSettings" ref="account-settings-inner-dropdown-arrows">
                                {{$t('accountSettings')}}
                                <img data-toggle="collapse" data-target="#collapseInnerAccountSettings" aria-expanded="false" aria-controls="collapseInnerAccountSettings" src="/static/images/icons/upArrow.svg" class="downCarret inner-arrow" />
                                <img data-toggle="collapse" data-target="#collapseInnerAccountSettings" aria-expanded="false" aria-controls="collapseInnerAccountSettings" src="/static/images/icons/upArrow.svg" class="upCarret inner-arrow" />
                              </a>
                              <div id="collapseInnerAccountSettings" class="collapse px-3" aria-labelledby="headingTwo" data-parent="#accordionExample" ref="innerDropdown1">
                                  <div v-if="roleId == 1 || roleId == 5 || roleId == 9 || roleId === roleInfo['Super Admin'] || roleId == roleInfo['RA Admin']" class="ptb-6 pl-15 inner-options" @click="openPopup('team')">{{$t('team')}}</div>
                                  <div v-if="roleId == 1 || roleId == 5 || roleId == 9 " class="ptb-6 pl-15 inner-options" @click="openPopup('services')">{{$t('services')}}</div>
                                  <div v-if="roleId == 1 || roleId == 5 || roleId == 9 " class="ptb-6 pl-15 inner-options" @click="openPopup('billing')">{{$t('billing')}}</div>
                              </div>
                          </div>
                          <div class="ptb-6 option-header" @click="openPopup('tour')">
                            {{$t('virtualTour')}}
                          </div>
                          <div class="pt-2-pb-6 option-header" @click="logout">
                            {{$t('logout')}}
                          </div>
                      </form>
                  </div>
                </li>
            </ul>
</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <ul class="mobileProfileSettings collapse" id="settingsDropDown">
      <div  class="break-line"></div>
      <li class="mobileProfileSettingsDropDown">
        <div class="mobileProfileDropDown">
            <div class="mobileProfileDropDownInner">
              <div class="icon-text-section">
                <!-- <img class="img-size first_item" src="/static/images/icons/user_profile_icon.svg" alt /> -->
               <div class="mobileProfilePlaceholder first_item">{{$t('profile')}}</div>
              </div>
                <div class="carretSection first_item">
                    <span>
                    <button data-toggle="collapse" data-target="#collapseUserProfile" data-parent="#accordion">
                        <img src="/static/images/icons/upArrow.svg" class="downCarret" />
                        <img src="/static/images/icons/upArrow.svg" class="upCarret" />
                    </button>
                    </span>
                </div>
            </div>
        </div>
        <div class="collapse mobileProfileItemsList" id="collapseUserProfile">
          <ul>
          <li class="mobileProfileItem">
            <button @click="openPopup('profile')" class="cursor_pointer" data-toggle="collapse" data-target="#collapseUserProfile">
          <!-- <img class="img-size" src="/static/images/icons/inmetro_user_profile.png" alt /> -->
          <span class="mobilePrfSettingsTxt">{{$t('userProfile')}}</span>
        </button>
          </li>
          <li class="mobileProfileItem last_item pt-9">
            <button @click="openPopup('companyProfile')" class="cursor_pointer" data-toggle="collapse" data-target="#collapseUserProfile">
            <!-- <img class="img-size" src="/static/images/icons/inmetro_company_profile.png" /> -->
            <span class="mobilePrfSettingsTxt">{{$t('companyProfile')}}</span>
            </button>
          </li>
        </ul>
        </div>
      </li>
      <li>
        <div class="horizontal-line"></div>
      </li>
      <li class="mobileProfileSettingsDropDown" v-if="roleId == 1 || roleId == roleInfo['Super Admin'] || roleId == roleInfo['RA Admin']">
        <div class="mobileProfileDropDown">
            <div class="mobileProfileDropDownInner">
              <div class="icon-text-section">
                <!-- <img class="img-size" src="/static/images/icons/account_settings_icon.svg" alt /> -->
               <div class="mobileProfilePlaceholder">{{$t('accountSettings')}}</div>
              </div>
                <div class="carretSection">
                    <span>
                    <button data-toggle="collapse" data-target="#collapseAccountSettings" data-parent="#accordion">
                        <img src="/static/images/icons/upArrow.svg" class="downCarret" />
                        <img src="/static/images/icons/upArrow.svg" class="upCarret" />
                    </button>
                    </span>
                </div>
            </div>
        </div>
        <div class="collapse mobileProfileItemsList" id="collapseAccountSettings">
          <ul>
          <li class="mobileProfileItem " v-if="roleId == 1 || roleId == 5 || roleId == 9 || roleId === roleInfo['Super Admin'] || roleId === roleInfo['RA Admin']" :class="roleId===roleInfo['RA Admin']?'mb-10':''">
            <button  @click="openPopup('team')" class="profileItemTitleOuter cursor_pointer" data-toggle="collapse" data-target="#collapseAccountSettings">
              <!-- <img class="img-size" src="/static/images/icons/team_account_settings.svg" /> -->
              <span class="mobilePrfSettingsTxt">{{$t('team')}}</span>
            </button>
          </li>
          <li class="mobileProfileItem last_item pt-9" v-if="roleId == 1 || roleId == 5 || roleId == 9 ">
            <button  @click="openPopup('services')" class="profileItemTitleOuter cursor_pointer" data-toggle="collapse" data-target="#collapseAccountSettings">
              <span class="mobilePrfSettingsTxt">{{$t('services')}}</span>
            </button>
          </li>
          <li class="mobileProfileItem last_item pt-9" v-if="roleId == 1 || roleId == 5 || roleId == 9 " >
            <button  @click="openPopup('billing')" class="profileItemTitleOuter cursor_pointer" data-toggle="collapse" data-target="#collapseAccountSettings">
              <span class="mobilePrfSettingsTxt">{{$t('billing')}}</span>
            </button>
          </li>
        </ul>
        </div>
      </li>
      <li v-if="roleId == 1 || roleId == roleInfo['Super Admin'] || roleId == roleInfo['RA Admin']">
        <div class="horizontal-line"></div>
      </li>
      <li class="mobileProfileSettingsDropDown">
        <div class="mobileProfileDropDown">
          <div class="mobileProfileDropDownInner">
            <div class="icon-text-section">
              <div class="mobileProfilePlaceholder">{{$t('language')}}</div>
            </div>
            <div class="carretSection">
              <span>
                <button data-toggle="collapse" data-target="#collapseLanguageDropdown" data-parent="#accordion">
                  <img src="/static/images/icons/upArrow.svg" class="downCarret" />
                  <img src="/static/images/icons/upArrow.svg" class="upCarret" />
                </button>
              </span>
            </div>
          </div>
          <div class="collapse mobileProfileItemsList" id="collapseLanguageDropdown">
            <ul>
              <li class="mobileProfileItem">
                <button data-toggle="collapse" data-target="#collapseLanguageDropdown" data-parent="#accordion">
                  <div class="profileItemTitleOuter">
                    <div class="mobilePrfSettingsTxt" @click="changeLanguage('English')">{{$t('english')}}</div>
                  </div>
                </button>
              </li>
              <li class="mobileProfileItem last_item pt-9">
                <button data-toggle="collapse" data-target="#collapseLanguageDropdown" data-parent="#accordion">
                  <div class="profileItemTitleOuter">
                    <div class="mobilePrfSettingsTxt" @click="changeLanguage('Portuguese')">{{$t('portuguese')}}</div>
                  </div>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li>
        <div class="horizontal-line"></div>
      </li>
      <li class="icon-text-section pl-29" @click="openPopup('tour')">
        <!-- <img class="img-size" src="/static/images/icons/tour_play_blue_icon.svg" alt /> -->
        <div class="mobileProfilePlaceholder virtual-tour-cursor">{{$t('virtualTour')}}</div>
      </li>
      <li>
        <div class="horizontal-line"></div>
      </li>
      <li class="mobileProfileSettingsDropDown mt-9">
        <span @click="logout" class="cursor_pointer">
          <!-- <img class="img-size" src="/static/images/icons/logout_icon_blue.svg" alt /> -->
          <span class="mobileProfilePlaceholder">{{$t('logout')}}</span>
        </span>
      </li>
    </ul>
    <!-- <base-popup
      ref="base_popup"
      :regWatchprefTab="regWatchprefTab"
      :userAction="userAction"
      @popUpClosed="popUpClosed"
      @logoutUser="logoutUser"
      @updateAddressMode="updateAddressMode"
      :account_id="account_id"
      :roleId="roleId"
      :isEdit="isEdit"
    ></base-popup> -->
    <generic-popup
      :genericPopupId="genericPopupId"
      :genericBody="'Renew Certificate'"
    ></generic-popup>
    <alerts :alertsList="alertsList"></alerts>
    <feedback-modal></feedback-modal>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import $ from 'jquery';
import EventBus from '../../utils/event-bus';
import BasePopup from '../ProfileAccountSettings/ProfileBasePopup.vue';
import FeedbackModal from '../Common/FeedbackModal.vue';
import GenericPopup from '../UIComponents/GenericPopup.vue';
import { postLanguagePreference } from '../../apis/languagePreferences';
import Alerts from './Alerts.vue';
import { getSubscriptions } from '../../apis/registrations';
import { getServicesInCart } from '../../apis/marketPlace';
import { getAlerts } from '../../apis/profile';
import { submitFeedback } from '../../apis/dashboard';
import Loader from '../UIComponents/Loader.vue';

// Listen for the i-got-clicked event and its payload.
export default {
  components: {
    BasePopup,
    GenericPopup,
    FeedbackModal,
    Alerts,
    Loader,
  },
  props: {
    roleId: Number,
    displaySide: Boolean,
    account_id: Number,
    userCompany: String,
    roleInfo: Object
  },
  data() {
    return {
      genericPopupId: 'genericPopupRenewCertificate',
      regWatchprefTab: '',
      userAction: '',
      loggedInUser: {},
      errors: [],
      loggedInInitials: '',
      imageData: '',
      loggedInInitialsFlag: false,
      activeMenuTitle: '',
      selectedLanguageLabel: '',
      languages: ['English', 'Portuguese'],
      subscriptions: [],
      alertsList: [],
      cart: [],
      isEdit: false,
      loaderStatus: false,
    };
  },
  computed: {
    profileName() {
      const fullname = Object.keys(this.loggedInUser).length ? `${this.loggedInUser.first_name} ${this.loggedInUser.last_name}` : '';
      if (fullname.length > 30) return `${fullname.substr(0, 27)}...`;
      return fullname;
    },
  },
  watch: {
    displaySide(val) {
      $(document.body).addClass('disableBodyScroll');
      if (!val) {
        $(document.body).removeClass('disableBodyScroll');
        if (!$('#userProfileSettings').hasClass('collapsed')) {
          $('#userProfileSettings').trigger('click');
        }
      }
    },
  },
  methods: {
    async submit(data) {
      const response = await submitFeedback(data);
      if (response.status === 204) {
        this.loaderStatus = false;
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'Portuguese' ? 'Feedback enviado com sucesso!' : 'Feedback sent successfully!',
          group: 'custom-notification',
        });
      } else {
        this.loaderStatus = false;
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Erro ao enviar feedback!' : 'Error while sending feedback',
          group: 'custom-notification',
        });
      }
    },
    openFeedback() {
      $('#feedbackModal').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    updateAddressMode() {
      this.isEdit = false;
    },
    async getCart() {
      this.cart = await getServicesInCart();
    },
    async openAlertsModal() {
      const response = await getAlerts();
      if (response) {
        this.alertsList = response.data;
        $('#alertsModal').modal();
      }
    },
    async changeLanguage(language) {
      const payload = { language: '' };
      if (language === 'Portuguese') {
        payload.language = 'pt-BR';
      } else {
        payload.language = 'en-US';
      }
      await postLanguagePreference(payload);
      const oldLanguage = localStorage.getItem('language');

      if (['Portuguese', 'Português'].includes(language)) {
        this.selectedLanguageLabel = 'Português';
        this.languages = ['Inglês', 'Português'];
        this.$i18n.locale = 'Portuguese';
        EventBus.$emit('activeMenuTitle', this.$route.meta.title);
        EventBus.$emit('labelNameEmitted', 'Nome dos laboratórios', 'Nome dos Organismos de Certificação');
        EventBus.$emit('standardsApplicableEmitted');
        EventBus.$emit('updateLanguage', 'Portuguese', oldLanguage);
        EventBus.$emit('languageUpdate', 'Portuguese', oldLanguage);
      } else {
        this.selectedLanguageLabel = 'English';
        this.languages = ['English', 'Portuguese'];
        this.$i18n.locale = 'English';
        EventBus.$emit('activeMenuTitle', this.$route.meta.title);
        EventBus.$emit('labelNameEmitted', 'Name of Labs', 'Name of Certification Bodies');
        EventBus.$emit('standardsApplicableEmitted');
        EventBus.$emit('updateLanguage', 'English', oldLanguage);
        EventBus.$emit('languageUpdate', 'English', oldLanguage);
      }
      localStorage.setItem('language', this.$i18n.locale);
    },
    portugueseHeaders(title) {
      switch (title) {
        case 'Dashboard':
          title = 'Painel';
          break;
        case 'Marketplace':
          title = 'Marketplace';
          break;
        case 'Notifications':
          title = 'Notificações';
          break;
        case 'Compliance Tracker':
          title = 'Rastreador de Conformidade';
          break;
        case 'Resources':
          title = 'Recursos';
          break;
        case 'Help & Support':
          title = 'Ajuda e suporte';
          break;
        case 'Launchpad':
          title = 'Plataforma de lançamento';
          break;
        default:
          title = '';
          break;
      }
      return title;
    },
    popUpClosed() {
      this.$emit('accountSettingsPopUpClose');
      if (this.userAction === 'profile') {
        EventBus.$emit('updateProfile', true);
      }

      this.userAction = '';
      $('#basePopup').modal('hide');
    },
    setDropDownsToDefaultView() {
      this.$refs.dropdown.classList.remove('open');
      this.$refs['account-settings-dropdown-arrows'].setAttribute('aria-expanded', 'false');
      this.$refs.innerDropdown.classList.remove('in');
      this.$refs['profile-dropdown-arrows'].setAttribute('aria-expanded', 'false');
      if (this.$refs.innerDropdown1) {
        this.$refs.innerDropdown1.classList.remove('in');
        this.$refs['account-settings-inner-dropdown-arrows'].setAttribute('aria-expanded', 'false');
      }
    },
    openPopup(data, type) {
      this.setDropDownsToDefaultView();
      this.$emit('mobilesidebar');
      if (type === 'addrecord') {
        this.isEdit = true;
      } else this.isEdit = false;
      this.regWatchprefTab = '';
      this.userAction = data;
      if (data === 'tour') {
        EventBus.$emit('displayTour');
        return;
      }
      // if (data === 'companyProfile') {
      //   this.$refs.base_popup.profileMenuClicked = 'companyProfile';
      // }
      // $('#basePopup').modal({
      //   backdrop: 'static',
      //   keyboard: false,
      // });
      const pageName = this.$route.query ? this.$route.query.page : '';
      if (pageName !== data) {
        this.$router.push(`/layout/account-settings?page=${data}`);
      }
    },
    comment() {
      this.$router.push('/layout/support');
    },
    async logout() {
      socket.removeAllListeners(`alertSaveMultiRegistrationDetails_${localStorage.getItem('userId')}`);
      document.cookie = 'Authorization=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      document.cookie = 'redirect_url=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push('/login');
    },
    getInitials(firstname, lastname) {
      return `${firstname ? firstname.charAt(0).toUpperCase() : ''}${lastname ? lastname.charAt(0).toUpperCase() : ''}`;
    },
    loadProfile() {
      this.loggedInUser = JSON.parse(localStorage.getItem('profileData'));
      this.imageData = this.loggedInUser.profile_pic;
      if (this.imageData === '' || this.imageData === null) {
        this.loggedInInitialsFlag = true;
      } else {
        this.loggedInInitialsFlag = false;
      }
      this.loggedInInitials = this.loggedInUser ? this.getInitials(this.loggedInUser.first_name, this.loggedInUser.last_name) : '';
    },
    logoutUser() {
      this.logout();
    },
    storageEventListener() {
      if (localStorage.getItem('updateIdle')) {
        EventBus.$emit('resetTimer');
      }
      if (localStorage.getItem('removeIdlePopups') === 'true') {
        if ($('#warningTimeout').is(':visible')) {
          $('#warningTimeout').modal('hide');
          EventBus.$emit('resetTimer');
        }
        localStorage.removeItem('removeIdlePopups');
      }
      if (localStorage.getItem('reLoad') && localStorage.getItem('reLoad') === 'true') {
        window.location.href = `${window.location.origin}/layout/dashboard`;
      }
      if (localStorage.length <= 0) {
        this.$router.push('/login');
      }
    },
  },
  async created() {
    this.subscriptions = await getSubscriptions(true);
    this.getCart();
    const response = await getAlerts();
    this.alertsList = response.data;
    EventBus.$on('submitFeedbackEvent', (data) => {
      this.loaderStatus = true;
      this.submit(data);
    });
    EventBus.$on('updateCart', () => {
      this.getCart();
    });
    EventBus.$on('addAddress', () => {
      this.openPopup('companyProfile', 'addrecord');
    });
    EventBus.$on('updateCompanyAddress', () => {
      this.$refs.base_popup.closepopup('closeBasePopup');
      this.updateAddressMode();
    });
    const lan = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
    this.selectedLanguageLabel = lan === 'Portuguese' ? 'Português' : 'English';
    this.$i18n.locale = lan;
    const reqPath = document.cookie.replace(
      /(?:(?:^|.*;\s*)RequestedPath\s*\=\s*([^;]*).*$)|^.*$/, // eslint-disable-line no-useless-escape
      '$1',
    );
    if (reqPath != null && reqPath.length > 0) {
      document.cookie = 'RequestedPath=; expires=Thu, 01 Jan 1970 00:00:00 GMT';
      this.$router.push(reqPath);
    }
    EventBus.$on('activeMenuTitle', (data) => {
      if (this.$i18n.locale === 'Portuguese') {
        this.activeMenuTitle = this.portugueseHeaders(data);
      } else {
        this.activeMenuTitle = data;
      }
    });
    if (this.$i18n.locale === 'Portuguese') {
      this.activeMenuTitle = this.portugueseHeaders(this.$route.meta.title);
    } else {
      this.activeMenuTitle = this.$route.meta.title;
    }
    // this.activeMenuTitle = this.$route.meta.title;
    EventBus.$on('updateProfile', () => {
      this.loadProfile();
    });
    EventBus.$on('navigateToServiceTab', (data) => {
      this.openPopup(data);
      $(`#${this.genericPopupId}`).modal({
        backdrop: 'static',
        keyboard: false,
      });
    });
    if (this.$i18n.locale === 'Portuguese') {
      this.languages = ['Inglês', 'Português'];
      this.selectedLanguageLabel = 'Português';
    }
  },
  mounted() {
    this.loadProfile();
    window.addEventListener('storage', this.storageEventListener, false);
    EventBus.$on('notificationSettings', (data) => {
      this.regWatchprefTab = 'RegWatch';
      this.userAction = data;
      $('#basePopup').modal({
        backdrop: 'static',
        keyboard: false,
      });
    });
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.storageEventListener);
    EventBus.$off('addAddress');
    EventBus.$off('updateCompanyAddress');
  },
};
</script>
<style scoped>
.mt-7-mb-3 {
  margin: 7px 0 0 0;
}
.mt-7-mb-3 div[aria-expanded="true"] {
  padding-top: 5px;
}
.user-profile-wrapper div[aria-expanded="true"] {
  padding-top: 2px;
}
.dropdown-wrapper a[aria-expanded="true"] span img.upCarret {
  display: inline-block;
  transform: rotate(0deg) !important;
}
.dropdown-wrapper a[aria-expanded="true"] span img.downCarret {
  display: none;
}
.dropdown-wrapper a span img.downCarret {
  display: inline-block;
  width: 24px;
  height: 24px;
}
.pt-2-pb-6 {
  padding: 2px 0px 6px 0px;
}
.dropdown-wrapper a span img.upCarret {
  display: none;
  transform: rotate(180deg);
  width: 24px;
  height: 24px;
}
.profile-wrapper[aria-expanded="true"] img.upCarret {
  display: inline-block;
}
.profile-wrapper[aria-expanded="true"] img.downCarret {
  display: none;
}
.profile-wrapper img.downCarret {
  display: inline-block;
  width: 24px;
  height: 24px;
  transform: rotate(180deg);
}
.profile-wrapper img.upCarret {
  display: none;
  width: 24px;
  height: 24px;
}
.accountsettings-wrapper[aria-expanded="true"] img.upCarret {
  display: inline-block;
}
.accountsettings-wrapper[aria-expanded="true"] img.downCarret {
  display: none;
}
.accountsettings-wrapper img.downCarret {
  display: inline-block;
  width: 24px;
  height: 24px;
  transform: rotate(180deg);
}
.accountsettings-wrapper img.upCarret {
  display: none;
  width: 24px;
  height: 24px;
}
.ptb-6 {
  padding: 7px 0 5px 0;
}
.option-header {
  padding-left: 17px;
  cursor: pointer;
  color: #4D4D4D;
}
.pl-15 {
  padding-left: 31px;
  cursor: pointer;
}
.inner-options:hover {
  background: #E6E6E6;
}
.inner-arrow {
  position: absolute;
  right: 20px;
}
.mt-9 {
  margin-top: 9px !important;
}
.profile-title {
  padding: 7px 3px 7px 7px;
}
.mt-7{
 margin-top:7px;
}
.ptb-13{
  padding-top:13px;
  padding-bottom: 13px
}
.ptb-11 {
  padding-top:11px;
  padding-bottom: 13px
}
.top-3 {
  position: relative !important;
  top: -3px !important;
}
.div-center {
  padding: 9px 16px 9px 16px;
}
/* Language dropdown styles start  */
.lang-dropdown{
    width: 146px;
}
.lang-dropdown .multiselect--active
  >>> .multiselect__content-wrapper::before{
    content: '';
    position: absolute;
    top: 0;
    left: 10px;
    border: 0.5px solid #333333;
    opacity:0.5;
    width: 91%;
}
.lang-dropdown .multiselect-single-dropdown.multiselect--active::before {
  content: none;
}
.lang-dropdown .multiselect-single-dropdown
>>> .multiselect__content-wrapper ul li:first-child{
  margin-top: 6px !important;
}
.lang-dropdown .multiselect-single-dropdown
>>> .multiselect__select{
 position: absolute;
    width: 40px;
    height: 38px;
    right: 1px;
    top: 1px;
    padding: 6px 6px 10px 0px;
    text-align: center;
    transition: transform .2s ease, -webkit-transform .2s ease;
}
.lang-dropdown .multiselect--active
>>> .multiselect__select{
  padding-top: 5px !important;
  padding-bottom: 7px;
  padding-left: 13px;
  padding-right: 7px;
}
.lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__placeholder{
    color: #333333;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #333333;
    overflow: visible;
    padding-left:0px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #4D4D4D;
    overflow: visible;
    padding-left:0px;
  }
  .lang-dropdown .multiselect--active
  >>> .multiselect__placeholder{
    display: block !important;
  }
  .multiselect--above.multiselect--active
  >>>  .multiselect__single,
  .multiselect--above.multiselect--active
  >>> .multiselect__placeholder{
    padding: 4px 40px 4px 12px;
  }
  .lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-radius: 3px !important;
    background: #FFFFFF;
    height: 33px;
    padding: 2px 40px 4px 16px;
  }
  .lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__select:before{
    position: relative;
    right: 0;
    color: #4D4D4D;
    margin-top: 4px;
    border-color:  #4D4D4D transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0;
    content: "";
    transform: rotate(0) !important;
    padding: 0px !important;
    border-top-left-radius: 0px !important;
    border-top-right-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-bottom: none !important;
  }
  .lang-dropdown .multiselect--active
  >>> .multiselect__content-wrapper{
    border-top: none !important;
    margin-top: 0px !important;
    border: 0.5px solid #000000;
  }
  .lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    margin-top: 0px !important;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .lang-dropdown .multiselect--active
  >>> .multiselect__tags{
    border-radius: 0px !important;
    border-bottom: 0px;
  }
  .lang-dropdown .multiselect--active
  >>> .multiselect__option:hover{
    border:1px solid #0A99ff !important;
  }
  .lang-dropdown .multiselect--active
  >>> .multiselect__option.multiselect__option--highlight{
    /* border:1px solid #0A99ff!important; */
  }
  .lang-dropdown .multiselect--active
  >>> .multiselect__option.multiselect__option--highlight span{
  }
  .lang-dropdown .multiselect--above.multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #333333;
  }
  .lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element{
    float: unset !important;
  }
  .lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #333333;
  }
  .lang-dropdown .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 12px;
    padding-top:6px;
    padding-bottom: 0px;
    padding-right: 0px;
  }
.pl-13{
  padding-left: 13px !important;
}
.pt-9 {
  padding-top: 9x;
}
.pl-29 {
  padding-left: 29px;
}
.virtual-tour-cursor {
  cursor: pointer;
}
.pt-9{
  padding-top: 9px;
}
.profileCarret{
  width: 16px;
  height: 16px;
}
.first_item{
  margin-top: 0px !important;
  margin-bottom: 9px;
}
.last_item{
  margin-bottom: 9px;
}
.horizontal-line {
    border-bottom: 1px solid #D3D6D9;
    margin: 0 28px;
  }
.carretSection span button[aria-expanded="true"] img.upCarret{
        display: inline-block;
    }
  .carretSection span button[aria-expanded="true"] img.downCarret{
        display: none;
    }
  .carretSection span button img.downCarret {
        display: inline-block;
        transform: rotate(180deg);
    }
  .carretSection span button img.upCarret{
        display: none;
    }
    .mobileProfileDropDownInner{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .mobileProfilePlaceholder{
    margin-left: 21px;
    margin-top: 9px;
    margin-bottom: 9px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: #000000;
  }
  .mobileProfileDropDownInner button,
  .userProfileCarret button{
    background-color: transparent !important;
      padding: 0px;
      border: none;
  }
  .mobileProfileItemsList button,
  .userProfileCarret button{
    background-color: transparent !important;
      padding: 0px;
      border: none;
  }
  .help-support .carretSection {
    align-items: unset;
  }
  .carretSection{
    padding-right: 28px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .userProfileCarret {
    /* padding-top: 61px; */
    /* padding-right: 12px; */
    padding: 13px 0px 13px 0px;
  }
  .userProfileCarret img{
    width: 24px;
    height: 24px;
  }
    .icon-text-section{
      display: flex;
      align-items: center;
    }
    /* .downCarret,
    .upCarret{
      width: 19px;
      height: 19px;
    } */
    .mobileProfileItemsList ul li button .profileItemTitleInner{
      /* padding-left: 28px; */
      color: #01518a;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
    }
    .mobileProfileItemsList ul li button{
      padding-left: 0px !important;
    }
    .mobileProfileItemsList ul li .profileItemTitleOuter{
      padding-left: 0px !important;
      /* padding-top: 12px; */
    }
    .mobileProfileItemsList ul{
      padding-left: 29px;
    }
    .mobileProfileItem{
      margin-right: auto;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 300;
      font-size: 14px;
      line-height: 19px;
      color: #01518a;
      margin-top: 9px;
    }
ul{
  list-style-type: none;
  padding-left: 0px;
}
.break-line{
  margin-left: 16px;
  margin-right: 16px;
  margin-bottom: 9px;
  border: 0.6px solid #B4B4B4;
}
.ml-13{
  margin-left: 13px;
}
.mobile-screen-caret {
  position: absolute;
  top: 7px;
  right: -23px;
}

.mobile-user-info {
  display: flex;
  align-items: center;
}

.ellipsis-profile-name {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
  float: left;
  padding-right: 4px;
}

.profile-pic {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  /* margin-top: 53px; */
  margin-right: 9px;
}

.dropdown.icon {
  top: 6px;
  left: 6px;
  padding: 9px 0 0 7px;
}

.logo-text {
  float: left;
  padding: 11px 0 12px 0px;
  margin-bottom: 0px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  color: #CA0123;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.l1 {
  position: absolute;
   height: 15px;
  margin: 18px 0px 18px 0px;
  border-left: 2px solid #D3D3D3;;
  float: left;
}
.dropdown-menu {
  top: 40px;
  right: -11px;
  left: auto;
  padding: 10px 0 6px 0;
  min-width: 238px;
  font-size: 16px;
  color: #4D4D4D;
}
.dropdown-menu::after {
  content: '';
  position: absolute;
  right: 17px;
  top: -6.5px;
  width: 12px;
  height: 12px;
  background: inherit;
  transform: rotate(45deg);
  border-style: solid;
  border-width: 1px 0 0 1px;
  border-color: rgba(0, 0, 0, 0.3) transparent transparent rgba(0, 0, 0, 0.3);
  box-shadow: 0px -2px -3px 0px rgba(34, 36, 38, 0.15);
  z-index:9998;
}
.mt-7 {
  margin-top: 7px;
}
.ml-13 {
  margin-left: 13px;
}
.mr-4 {
  padding-right:4px
}
.content-ht {
  max-height: 50px;
}
.cursor_pointer {
  cursor: pointer;
}
.mobilePrfSettingsTxt {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #000000;
  vertical-align: middle;
  margin-left: 10px;
}
.mobileProfileSettingsDropDown {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #01518a;
  padding-left: 29px;
}
.downCarret {
  transform: rotate(180deg);
}
.parentCollapse > .downCarret {
  display: none;
}
.parentCollapse.collapsed > .downCarret {
  display: inline-block;
}
.parentCollapse > .upCarret {
  display: inline-block;
}
.parentCollapse.collapsed > .upCarret {
  display: none;
}
.mobileProfileSettings {
  position: fixed;
  width: 256px;
  top: 0;
  bottom: 0;
  background: #F5F5F5;
  left: 0;
  margin-top: 119px;
  color: black;
  z-index: 100;
  max-height: calc(100vh - 118px);
  overflow-y: auto;
  height: 100% !important;
}
.mobileProfileSettings::-webkit-scrollbar {
  width: 6px;
}
.mobileProfileSettings::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
.mobileProfileSettings::-webkit-scrollbar-track-piece:end {
  margin-bottom: 20px;
}
.mobileProfileSettings::-webkit-scrollbar-track-piece:start {
  margin-top: 20px;
}
.profilePicMobile {
  width: 32px;
  height: 32px;
  border-radius: 68px;
}
.mobileHeader {
  display: none;
  /* padding: 10px; */
  padding-top: 29px;
  padding-left: 28px;
  background: #ffffff;
  position: fixed;
  width: 200px;
  float: left;
  height: 119px;
  z-index: 99;
}
.displayBlock {
  display: block !important;
}
@media only screen and (min-width: 1301px) {
  .cart-alert-icons {
    display: none;
  }
  .displayBlock {
    display: none !important;
  }
  .mobileProfileSettings {
    z-index: 0;
  }
}
.burger-toggle {
  margin: 10px 0px 0px 10px;
  float: left;
  display: none;
  cursor: pointer;
}
.pd-lt-0 {
  padding-left: 0px;
}
.userProfileDropDownMobile {
  vertical-align: middle;
  /* color: #fff; */
  position: relative;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 25px;
  color: #000000;
  margin-left: 8px;
  /* padding: 5px 4px 0 0 !important; */
  cursor: pointer;
}
.body-wrapper {
  /* box-shadow: 4px 4px 10px rgb(0 0 0 / 25%); */
  float: left;
  width: 100%;
  padding-left: 110px;
  z-index: 100;
  background: #ffffff;
  position: fixed;
  top: 0px;
  height: 50px;
  border-bottom: none;
  border-bottom: 1px solid #D3D3D3;
}
.logo_wrapper {
  /* padding: 28px 0px 31px 44px;  */
  /* display: flex;
  align-items: center;
  justify-content: center; */
  background: #ffffff;
  position: fixed;
  float: left;
  height: 50px;
  z-index: 101;
  border-bottom: none;
  border-bottom: 1px solid #D3D3D3;
}
.page-description {
font-family: 'Open Sans';
font-style: normal;
font-weight: 600;
font-size: 18px;
line-height: 25px;
color: #000000;
margin-bottom: 11px;
/* margin-top: 8px; */
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis;
}
.main-header {
  height: 50px;
  background: #fff;
  /* border-bottom: 1px solid #D3D3D3; */
}
.theme-admin .logo_wrapper,
.theme-admin .mobileHeader,
.theme-admin .body-wrapper {
  background: #709bb8;
}
.section-support {
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}
.help-support .section-support ul {
  margin: 8px 0;
  padding-inline-start: 15px;
}
li {
  list-style: none;
}
.help-support ul li {
  list-style: none;
  float: left;
}
@media only screen and (max-width: 1300px) {
  .body-wrapper {
    display: none;
  }
  .cart-alert-icons {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    align-items: center;
    right: 130px;
  }
  .logo_wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 25px 0px 25px;
    /* box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25); */
    border-bottom: 1px solid #D3D3D3;
  }
  .logo_wrapper img {
    float: right;
  }
  .burger-toggle {
    display: block;
  }
  .page-description {
    font-size: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .div-center {
    justify-content: flex-end;
  }
}
.avatar-background {
  background-size: cover;
  background-position: top center;
}
li.admin-title {
  background-color: #01518A;
  border-radius: 0px 0px 6px 6px;
  padding-top: 7px;
  padding-right: 33px;
  padding-bottom: 7px;
  padding-left: 34px;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  margin-right: 24px;
  margin-bottom: 0;
  margin-top: 0px;
  height:38px;
}
li.admin-title li {
  font-weight: 500;
}
@media (max-width: 1300px) {
  .mobile-user-info {
    font-size: 10px;
    margin-top: 0px;
  }
  .mobileHeader {
    /* padding-left: 2px; */
    width: 256px;
  }
  .logo_wrapper {
    z-index: 49;
  }
  .profilePicMobile {
    width: 32px;
    height: 32px;
    border-radius: 50px;
  }
}

.feedback {
  color: #01518A;
  font-size: 14px;
  padding-top:16px;
  padding-right: 32px;
  cursor: pointer;
}
.feedback img {
  padding: 0 4px 5px 0;
}
</style>
